import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { ImageViewerComponent }    from './image-viewer.component';
import { ImageViewerOptionsModel } from './typings/image-viewer.options';

@Injectable({
  providedIn: 'root'
})
export class ImageViewerService {
  constructor (
    private modalService: NgbModal
  ) {}

  // Resolves once the viewer is closed, however it was closed. `isFullHeight` sizes the modal to the viewport height.
  view ( src : string, options : ImageViewerOptionsModel = {} ) : Promise<void> {
    const modal = this.modalService.open(ImageViewerComponent, {
      windowClass: options.windowClass || ( options.isFullHeight ? 'image-viewer' : 'pull-up x-lg-modal' )
    });

    modal.componentInstance.hasFooter  = !!options.hasFooter;
    modal.componentInstance.isZoomable = !!options.isZoomable;
    modal.componentInstance.src        = src;

    return modal.result.then(() => undefined, () => undefined);
  }
}
